import { PAGE_TYPE } from '../constants/gaEnums';

/** content_id 조합: {content_type}_{id} → ex) album_456 */
export const buildContentId = (contentType, id) => `${contentType}_${id}`;

/** pathname → page_type 변환 */
export const getPageTypeFromPath = (pathname) => {
  if (pathname === '/') return PAGE_TYPE.HOME;
  if (pathname === '/reviews') return PAGE_TYPE.REVIEWS_MAIN;
  if (pathname.startsWith('/reviews/')) {
    const parts = pathname.split('/').filter(Boolean);
    // /reviews/{slug}/user-reviews/{id}
    if (parts.length >= 4 && parts[2] === 'user-reviews') return PAGE_TYPE.REVIEWS_DETAIL;
    // /reviews/{slug}/user-reviews
    if (parts.length === 3 && parts[2] === 'user-reviews') return PAGE_TYPE.REVIEWS_USERREVIEWS;
    return PAGE_TYPE.REVIEWS_POST;
  }
  if (pathname === '/news') return PAGE_TYPE.NEWS_MAIN;
  if (pathname.startsWith('/news/')) return PAGE_TYPE.NEWS_POST;
  if (pathname === '/lists') return PAGE_TYPE.LISTS_MAIN;
  if (pathname.startsWith('/lists/')) return PAGE_TYPE.LIST_POST;
  if (pathname === '/notice') return PAGE_TYPE.NOTICE_MAIN;
  if (pathname.startsWith('/notice/')) return PAGE_TYPE.NOTICE_POST;
  if (pathname.startsWith('/search')) return PAGE_TYPE.SEARCH;
  if (pathname.startsWith('/artists/')) {
    const parts = pathname.split('/').filter(Boolean);
    if (parts.length >= 4) return PAGE_TYPE.ARTIST_VIEW_ALL;
    return PAGE_TYPE.ARTIST;
  }
  if (pathname === '/mypage' || pathname.startsWith('/users/')) return PAGE_TYPE.MYPAGE;
  if (pathname === '/notification') return PAGE_TYPE.NOTIFICATION;
  return undefined;
};

/** 디바이스 유형 감지 */
export const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/tablet|ipad/i.test(ua)) return 'tablet';
  if (/mobile|android|iphone/i.test(ua)) return 'mobile';
  return 'pc';
};

/**
 * 공통 파라미터 반환
 * @param {object|null} user - 로그인 유저 (없으면 null)
 */
export const getCommonParams = (user) => ({
  login_status: user ? 'login' : 'guest',
  device_type: getDeviceType(),
});
